import React from 'react';
import Card from '../../../../componentes/contenedores/Card';
import Page from '../../../../componentes/plantilla/Page';
import { useContextEmpleado } from '../../../../contexto/empleado/EmpleadoContext';
import TablaClientes from './TablaBuscarClientes';

const HomeBuscarClientes = () => {
  const { listaClientes, setListaClientes, ActualizarLista } = useContextEmpleado();

  const datos = {
    titulo: {
      titulo: "Busqueda de clientes",
      url: "/app/admin/clientes/buscar",
      tituloUrl: "clientes",
      nombreUrl: "Buscar"
    }
  }

  return (
    <Page datos={datos}>
      <Card titulo="Lista de Clientes">
        <TablaClientes datos={listaClientes}></TablaClientes>
      </Card>
    </Page>
  )
}

export default HomeBuscarClientes;